import { batch } from 'react-redux';
import { actions } from 'react-redux-form';
import moment from 'moment';
import { httpDownload } from "../../../../../app/utils/api.utils";
import { FILE_ATTACHMENT_MODULES } from "../../../../constants/external-constants";

import { INVOICE_STATUS } from '../../../../constants/external-constants';
import {
    invoiceDetailsFormModel,
    fetchInvoiceDetails,
    fetchInvoiceStatus,
    fetchBillingAccountNumber,
    fetchSubAccountNumber,
    fetchAssignedUser,
    setInvoiceApprovedDateRequired
} from '../../../../constants/model-reducers/external/invoice/invoice/invoice-details.settings';
import { httpGet, httpPostFile, httpPost } from '../../../../utils/api.utils';
import { convertToLocalDateToUTCDate, convertDateStringToDateFormat } from '../../../../utils/helpers.utils';
import { DATE_FORMAT } from '../../../../utils/constant.utils';

export const invoiceDetailsFormInitialState = invoiceDetailsFormModel;

const defaultState = () => ({
    fetchFormInProgress: true,
    isInvoiceApprovedDateRequired: false,
    billingAccountNumberDropdown: [],
    subAccountNumberDropdown: [],
    statusDropdown: [],
    assignedUserDropdown: [],

    billingAccountsPage: 0,
    subAccountsPage: 0,
    assignedUsersPage: 0,

    hasMoreBillingAccounts: true,
    hasMoreSubAccounts: true,
    hasMoreAssignedUsers: true,

    isBillingAccountDropdownLoaded: false,
    isSubAccountDropdownLoaded: false,
    isAssignedUserDropdownLoaded: false,
});

const initialState = defaultState();

export const invoiceDetailsAction = {
    getInvoiceDetailsForm: (invoiceId) => async (dispatch) => {
        // Status
        var statusDropdown = await getInvoiceStatus();

        dispatch({
            type: fetchInvoiceStatus,
            data: statusDropdown
        });

        if (invoiceId) {
            var data = await getInvoiceDetails(invoiceId);

            if (data) {
                await dispatch(invoiceDetailsAction.getBillingAccounts(1, data?.BillingAccountNumber?.AccountNumber ?? ""));
                await dispatch(invoiceDetailsAction.getSubAccounts(1, data?.SubAccountNumber?.Value ?? ""));
                await dispatch(invoiceDetailsAction.getAssignedUsers(1, data?.AssignedUser?.Value ?? ""));
                batch(() => {
                    dispatch(actions.load("invoiceInvoiceDetailsForm.id", data.Id));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingAccountNumberId", data.BillingAccountNumber?.Id));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", data.BillingAccountNumber?.AccountNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.client", data.BillingAccountNumber?.Client));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.vendor", data.BillingAccountNumber?.Vendor));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceNumber", data.InvoiceNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.currency", data.BillingAccountNumber?.Currency));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.exchangeRate", data.BillingAccountNumber?.ExchangeRate == "0"? '0.00000000' : Number(data.BillingAccountNumber?.ExchangeRate).toFixed(8)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.remitId", data.BillingAccountNumber?.RemitId));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.apVendorId", data.BillingAccountNumber?.APVendorId));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.subAccountNumberId", data.SubAccountNumber?.Key));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.subAccountNumberDisplay", data.SubAccountNumber?.Value));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceDate", data.InvoiceDate != null ? convertDateStringToDateFormat(data.InvoiceDate) :null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.actualInvoiceMonth", data.ActualInvoiceMonth != null ? convertDateStringToDateFormat(data.ActualInvoiceMonth) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceExpectedDate", data.InvoiceExpectedDate != null ? convertDateStringToDateFormat(data.InvoiceExpectedDate) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceDueDate", data.InvoiceDueDate != null ? convertDateStringToDateFormat(data.InvoiceDueDate) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceApprovedDate", data.InvoiceApprovedDate != null ? convertDateStringToDateFormat(data.InvoiceApprovedDate) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingPeriodFrom", data.BillingPeriodFrom != null ? convertDateStringToDateFormat(data.BillingPeriodFrom) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingPeriodTo", data.BillingPeriodTo != null ? convertDateStringToDateFormat(data.BillingPeriodTo) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.rentalPeriodFrom", data.RentalPeriodFrom != null ? convertDateStringToDateFormat(data.RentalPeriodFrom) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.rentalPeriodTo", data.RentalPeriodTo != null ? convertDateStringToDateFormat(data.RentalPeriodTo) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceReceiptDate", data.InvoiceReceiptDate != null ? convertDateStringToDateFormat(data.InvoiceReceiptDate) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.assignedUserDisplay", data.AssignedUser.Value));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.assignedUserId", data.AssignedUser.Key));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.ediNumber", data.EDINumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.uploadDate", data.UploadDate != null ? convertDateStringToDateFormat(data.UploadDate) : null));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.uploadedBy", data.UploadedBy));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.creditNote", data.CreditNote));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoicePDF", data.InvoicePDF));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceAttachmentId", data.InvoiceAttachmentID));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalAmountDue", (data.TotalAmountDue ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalAmountToPay", (data.TotalAmountToPay ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.grossAmount", (data.GrossAmount ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.noOfChargedSubscription", data.NoOfChargedSubscription));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.remainingBalance", (data.RemainingBalance ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalTaxes", (data.TotalTaxes ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalNet", (data.TotalNet ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.lineItemsTotal", (data.LineItemsTotal ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.accountLevelCharges", (data.AccountLevelCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.usageCharges", (data.UsageCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.recurringCharges", (data.RecurringCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.miscellaneousCharges", (data.MiscellaneousCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.payments", (data.Payments ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.latePaymentFees", (data.LatePaymentFees ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.otherCharges", (data.OtherCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.checkNumber", data.CheckNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.amountPaid", (data.AmountPaid ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.paymentDate", data.PaymentDate != null ? convertDateStringToDateFormat(data.PaymentDate) : null));

                    if (data.InvoiceStatus) {
                        dispatch(actions.load("invoiceInvoiceDetailsForm.status", data.InvoiceStatus.Key));

                        var invoiceApprovedDateRequired = false;
                        if (data.InvoiceStatus.Key == INVOICE_STATUS.Processed || data.InvoiceStatus.Key == INVOICE_STATUS.ProcessedSentToAP) {
                            invoiceApprovedDateRequired = true;
                        }

                        dispatch({
                            type: setInvoiceApprovedDateRequired,
                            data: invoiceApprovedDateRequired
                        });
                    }

                    dispatch({ type: fetchInvoiceDetails, data: false });
                });

                return data;
            }
        }
    },

    getBillingAccounts: (page = 1, searchString = '') => async (dispatch, getState) => {
        const pageSize = 15;
        const existingAccounts = getState().invoiceInvoiceDetails.billingAccountNumberDropdown;

        const result = await getBillingAccountNumber(page, pageSize, searchString);

        let data = [];
        let hasMore = false;

        if (result) {
            data = page > 1 ? [...existingAccounts, ...result] : result;;
            hasMore = true;
        }

        dispatch({
            type: fetchBillingAccountNumber,
            payload: data,
            hasMoreBillingAccounts: hasMore,
            isBillingAccountDropdownLoaded: true,
            pageIndex: page
        });
    },

    getSubAccounts: (page = 1, searchString = '') => async (dispatch, getState) => {

        const pageSize = 15;

        const existingAccounts = getState().invoiceInvoiceDetails.subAccountNumberDropdown;
        const { invoiceInvoiceDetailsForm } = getState().form;

        const result = await getSubAccountNumber(invoiceInvoiceDetailsForm.billingAccountNumberId, searchString, page, pageSize);

        let data = [];

        let hasMore = false;

        if (result && result.length > 0) {
            data = [...existingAccounts, ...result];
            hasMore = true;

            dispatch({
                type: fetchSubAccountNumber,
                subAccount: data,
                hasMoreSubAccounts: hasMore,
                isSubAccountDropdownLoaded: false,
                pageIndex: page
            });
        }
    },

    getAssignedUsers: (page = 1, searchString = '') => async (dispatch, getState) => {
        const pageSize = 15;
        const existingAccounts = getState().invoiceInvoiceDetails.assignedUserDropdown;

        const result = await getInvoiceAssignedUser(searchString, page, pageSize);

        let data = [];
        let hasMore = false;

        if (result) {
            data = page > 1 ? [...existingAccounts, ...result] : result;;
            hasMore = true;
        }

        dispatch({
            type: fetchAssignedUser,
            payload: data,
            hasMoreAssignedUsers: hasMore,
            isAssignedUserDropdownLoaded: true,
            pageIndex: page
        });
    },

    searchBillingAccountNumber: (searchVal, propsName) => async (dispatch, state) => {
        const { billingAccountNumberDropdown } = state().invoiceInvoiceDetails;

        if (billingAccountNumberDropdown !== undefined && billingAccountNumberDropdown.length > 0) {
            var obj = billingAccountNumberDropdown.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchBillingAccountNumber, data: [] });
                return null;
            }
        }

        var data = await getBillingAccountNumber(searchVal);

        dispatch({
            type: fetchBillingAccountNumber,
            data: data
        });

        return data;
    },
    onChangeBillingAccountNumber: (value, propsName) => async (dispatch, state) => {
        const { billingAccountNumberDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || billingAccountNumberDropdown?.length === 0) {
            batch(() => {
                resetBillingAccountNumber(dispatch);
            });
        }
        else {
            const billingAccountNumber = billingAccountNumberDropdown.find(r => r["Id"] == value);
            setBillingAccountNumber(dispatch, billingAccountNumber);
            const searchVal = "";

            var data = await getSubAccountNumber(billingAccountNumber.Id, searchVal);

            dispatch({
                type: fetchSubAccountNumber,
                subAccount: data
            });
        }
    },
    searchSubAccountNumber: (searchVal, propsName) => async (dispatch, state) => {
        const { invoiceInvoiceDetailsForm } = state().form;
        const { subAccountNumberDropdown } = state().invoiceInvoiceDetails;

        if (subAccountNumberDropdown !== undefined && subAccountNumberDropdown.length > 0) {
            var obj = subAccountNumberDropdown.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchSubAccountNumber, subAccount: [] });
                return null;
            }
        }

        if (invoiceInvoiceDetailsForm.billingAccountNumberDisplay) {
            var data = await getSubAccountNumber(invoiceInvoiceDetailsForm.billingAccountNumberDisplay, searchVal);

            dispatch({
                type: fetchSubAccountNumber,
                subAccount: data
            });
            return data;
        }
        else {
            dispatch({ type: fetchSubAccountNumber, subAccount: [] });
            return null;
        }
    },
    onChangeSubAccountNumber: (value, propsName) => (dispatch, state) => {
        const { subAccountNumberDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || subAccountNumberDropdown?.length === 0) {
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
        }
        else {
            const subAccountNumber = (subAccountNumberDropdown ?? []).find(r => r["Key"] == value);
            if (subAccountNumber) {
                dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", subAccountNumber.Key));
                dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", subAccountNumber.Value));
            }
        }
    },
    searchAssignedUser: (searchVal, propsName) => async (dispatch, state) => {
        const { assignedUserDropdown } = state().invoiceInvoiceDetails;

        if (assignedUserDropdown !== undefined && assignedUserDropdown.length > 0) {
            var obj = assignedUserDropdown.find(o => o[propsName].trim() === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchAssignedUser, data: [] });
                return null;
            }
        }

        var data = await getInvoiceAssignedUser(searchVal);

        dispatch({
            type: fetchAssignedUser,
            data: data
        });
        return data;
    },
    onChangeAssignedUser: (value, propsName) => (dispatch, state) => {
        const { assignedUserDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || assignedUserDropdown?.length === 0) {
            batch(() => {
                resetAssignedUser(dispatch);
            });
        }
        else {
            const assignedUser = assignedUserDropdown.find(r => r["Key"] == value);
            setAssignedUser(dispatch, assignedUser);
        }
    },
    onChangeStatus: (model, value) => (dispatch) => {
        var invoiceApprovedDateRequired = false;

        batch(() => {
            dispatch(actions.change(model, value));

            if (value == INVOICE_STATUS.Processed || value == INVOICE_STATUS.ProcessedSentToAP) {
                invoiceApprovedDateRequired = true;
            }

            dispatch({
                type: setInvoiceApprovedDateRequired,
                data: invoiceApprovedDateRequired
            });
        });
    },
    downloadInvoiceFile: (invoiceID, invoiceUploadFileNameID, fileName) => async () => {

        await httpDownload('common/fileAttachment/downloadInvoiceFile/'
                + FILE_ATTACHMENT_MODULES.invoiceFileAttachment + '/'
                + invoiceID + '/'
                + invoiceUploadFileNameID + '/'
                + encodeURIComponent(fileName))
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === "undefined") {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                    }
                });
    },
    saveInvoiceForm: (invoiceId, validate, invoiceFile) => async (dispatch, state) => {
        try {
            const { form: { forms: { invoiceInvoiceDetailsForm: { $form } } } } = state();
            const { invoiceInvoiceDetailsForm } = state().form;

            var formData = new FormData();
            formData.append("InvoiceId", parseInt(invoiceId));
            formData.append("BillingAccountNumberId", parseInt(invoiceInvoiceDetailsForm.billingAccountNumberId));
            formData.append("SubAccountNumberId", invoiceInvoiceDetailsForm.subAccountNumberId != null ? parseInt(invoiceInvoiceDetailsForm.subAccountNumberId) : "");
            formData.append("InvoiceNumber", invoiceInvoiceDetailsForm.invoiceNumber);
            formData.append("StatusId", parseInt(invoiceInvoiceDetailsForm.status));
            formData.append("ActualInvoiceMonth", invoiceInvoiceDetailsForm.actualInvoiceMonth ? moment(invoiceInvoiceDetailsForm.actualInvoiceMonth).toISOString(true) : "");
            formData.append("InvoiceExpectedDate", moment(invoiceInvoiceDetailsForm.invoiceExpectedDate).toISOString(true));
            formData.append("InvoiceDate", convertToLocalDateToUTCDate(invoiceInvoiceDetailsForm.invoiceDate, false, DATE_FORMAT.ISO));
            formData.append("InvoiceDueDate", moment(invoiceInvoiceDetailsForm.invoiceDueDate).toISOString(true));
            formData.append("InvoiceApprovedDate", invoiceInvoiceDetailsForm.invoiceApprovedDate ? moment(invoiceInvoiceDetailsForm.invoiceApprovedDate).toISOString(true) : "" );
            formData.append("BillingPeriodFrom", moment(invoiceInvoiceDetailsForm.billingPeriodFrom).toISOString(true));
            formData.append("BillingPeriodTo", moment(invoiceInvoiceDetailsForm.billingPeriodTo).toISOString(true));
            formData.append("RentalPeriodFrom", moment(invoiceInvoiceDetailsForm.rentalPeriodFrom).toISOString(true));
            formData.append("RentalPeriodTo", moment(invoiceInvoiceDetailsForm.rentalPeriodTo).toISOString(true));
            formData.append("InvoiceReceiptDate", invoiceInvoiceDetailsForm.invoiceReceiptDate ? moment(invoiceInvoiceDetailsForm.invoiceReceiptDate).toISOString(true) : "");
            formData.append("AssignedUserId", parseInt(invoiceInvoiceDetailsForm.assignedUserId));
            formData.append("EDINumber", invoiceInvoiceDetailsForm.ediNumber ?? '');
            formData.append("CreditNote", invoiceInvoiceDetailsForm.creditNote);
            formData.append("TotalAmountDue", parseFloat(invoiceInvoiceDetailsForm.totalAmountDue));
            formData.append("RemainingBalance", invoiceInvoiceDetailsForm.remainingBalance ? parseFloat(invoiceInvoiceDetailsForm.remainingBalance) : "");
            formData.append("Payments", invoiceInvoiceDetailsForm.payments ? parseFloat(invoiceInvoiceDetailsForm.payments) : "");
            formData.append("LatePaymentFees", invoiceInvoiceDetailsForm.latePaymentFees ? parseFloat(invoiceInvoiceDetailsForm.latePaymentFees) : "");
            formData.append("OtherCharges", invoiceInvoiceDetailsForm.otherCharges ? parseFloat(invoiceInvoiceDetailsForm.otherCharges) : "");
            formData.append("AmountPaid", invoiceInvoiceDetailsForm.amountPaid ? parseFloat(invoiceInvoiceDetailsForm.amountPaid) : "");
            formData.append("PaymentDate", invoiceInvoiceDetailsForm.paymentDate ? moment(invoiceInvoiceDetailsForm.paymentDate).toISOString(true) : "");
            formData.append("CheckNumber", invoiceInvoiceDetailsForm.checkNumber ?? '');
            var removePDFFile = ($form.loadedValue.invoicePDF !== "" || $form.loadedValue.invoicePDF !== null) && (invoiceInvoiceDetailsForm.invoicePDF == "" || invoiceInvoiceDetailsForm.invoicePDF == null);
            formData.append("IsRemovePDFFile", removePDFFile);
         
            if (removePDFFile == false) {
                if (invoiceFile !== null) {
                    formData.append("File", invoiceFile);
                }
            }

            var result = await saveInvoice(validate, formData);

            if (result.success && validate == false) {
                dispatch(actions.load("invoiceInvoiceDetailsForm", invoiceInvoiceDetailsForm));
            }

            return result;
        }
        catch (e) {
            return e;
        }
    },

    deleteInvoiceForm: (invoiceId) => async (dispatch, state) => {
        try {
            var result = await deleteInvoice(invoiceId);

            return result;
        }
        catch (e) {
            return e;
        }
    },

    resetInvoiceDetailsForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.load("invoiceInvoiceDetailsForm", invoiceDetailsFormInitialState));
            dispatch(actions.reset("invoiceInvoiceDetailsForm"));
            dispatch({ type: fetchInvoiceDetails, data: true });
        })
    }
};

function resetBillingAccountNumber(dispatch) {
    dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberId", invoiceDetailsFormInitialState.billingAccountNumberId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", invoiceDetailsFormInitialState.billingAccountNumberDisplay));
    dispatch(actions.change("invoiceInvoiceDetailsForm.client", invoiceDetailsFormInitialState.client));
    dispatch(actions.change("invoiceInvoiceDetailsForm.vendor", invoiceDetailsFormInitialState.vendor));
    dispatch(actions.change("invoiceInvoiceDetailsForm.currency", invoiceDetailsFormInitialState.currency));
    dispatch(actions.change("invoiceInvoiceDetailsForm.exchangeRate", invoiceDetailsFormInitialState.exchangeRate));
    dispatch(actions.change("invoiceInvoiceDetailsForm.remitId", invoiceDetailsFormInitialState.remitId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.apVendorId", invoiceDetailsFormInitialState.apVendorId));

    dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
}

function setBillingAccountNumber(dispatch, billingAccountNumber) {
    if (billingAccountNumber) {
        batch(() => {
            dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberId", billingAccountNumber.Id));
            dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", billingAccountNumber.AccountNumber));
            dispatch(actions.change("invoiceInvoiceDetailsForm.client", billingAccountNumber.Client));
            dispatch(actions.change("invoiceInvoiceDetailsForm.vendor", billingAccountNumber.Vendor));
            dispatch(actions.change("invoiceInvoiceDetailsForm.currency", billingAccountNumber.Currency));
            dispatch(actions.change("invoiceInvoiceDetailsForm.exchangeRate", billingAccountNumber.ExchangeRate));
            dispatch(actions.change("invoiceInvoiceDetailsForm.remitId", billingAccountNumber.RemitId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.apVendorId", billingAccountNumber.APVendorId));

            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
        })
    }
    else {
        batch(() => {
            resetBillingAccountNumber(dispatch);
        });
    }
}

function resetAssignedUser(dispatch) {
    dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserId", invoiceDetailsFormInitialState.assignedUserId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserDisplay", invoiceDetailsFormInitialState.assignedUserDisplay));
}

function setAssignedUser(dispatch, assignedUser) {
    if (assignedUser) {
        batch(() => {
            dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserId", assignedUser.Key));
            dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserDisplay", assignedUser.Value));
        })
    }
}

async function getInvoiceDetails(invoiceId) {
    try {
        var result = await httpGet(`external/invoice/details/${invoiceId ?? 0}`);

        return result.data;
    }
    catch (e) {
        return null;
    }
}

async function getBillingAccountNumber(page = 1, pageSize = 15, searchVal = "") {
    try {
        let url = `external/invoice/billing-account-number-dropdown/${page}/${pageSize}`;
        if (searchVal) url += `?searchVal=${encodeURIComponent(searchVal)}`;
        var result = await httpGet(url);
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getSubAccountNumber(accountNumber, searchVal = "", page = 1, pageSize = 15) {
    try {
        // path style to match action creator
        const accNumber = parseInt(accountNumber, 10);
        let url = `external/invoice/sub-account-number-dropdown/${accNumber}/${page}/${pageSize}`;
        if (searchVal) url += `?searchVal=${encodeURIComponent(searchVal)}`;
        var result = await httpGet(url);
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getInvoiceStatus() {
    try {
        var result = await httpGet(`external/invoice/status-dropdown`);

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getInvoiceAssignedUser(searchVal = "", page = 1, pageSize = 15) {
    try {
        // path style to match action creator
        let url = `external/invoice/assigned-user-dropdown/${page}/${pageSize}`;
        if (searchVal) url += `?searchVal=${encodeURIComponent(searchVal)}`;
        var result = await httpGet(url);
        return result.data;
    }
    catch (e) {
        return [];
    }
}
async function saveInvoice(validate, data) {
    try {
        validate = validate ? 1 : 0;
        var result = await httpPostFile(`external/invoice/details/save/${validate}`, data);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Invoice is not saved. Error encountered while on saving."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}

async function deleteInvoice(invoiceId) {
    try {
        const dealName = sessionStorage.getItem('DealName');
        var result = await httpPost('external/invoice/deleteInvoice/' + invoiceId);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Invoice is not deleted. Error encountered while deleting."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case fetchInvoiceDetails:
            return {
                ...state,
                fetchFormInProgress: action.data
            };
        case fetchInvoiceStatus:
            return {
                ...state,
                statusDropdown: action.data
            };
        case fetchBillingAccountNumber:
            return {
                ...state,
                billingAccountNumberDropdown: action.payload,
                billingAccountsPage: action.pageIndex,
                isBillingAccountDropdownLoaded: action.isBillingAccountDropdownLoaded
            };
        case fetchSubAccountNumber:
            return {
                ...state,
                subAccountNumberDropdown: action.subAccount,
                isSubAccountDropdownLoaded: action.isSubAccountDropdownLoaded,
                subAccountsPage: action.pageIndex ?? 1
            };
        case setInvoiceApprovedDateRequired:
            return {
                ...state,
                isInvoiceApprovedDateRequired: action.data
            };
        case fetchAssignedUser:
            return {
                ...state,
                assignedUserDropdown: action.payload,
                assignedUsersPage: action.pageIndex,
                isAssignedUserDropdownLoaded: action.isAssignedUserDropdownLoaded
            };
        default:
            return state;
    } 
}